const React = require('react');
const isNode = (typeof process !== 'undefined');

class SearchResults extends React.Component {
    render() {
        const { q, result, typeMap } = this.props;
        return (
        <section className="searchResults">
            <div className="searchResults__container">
                <h2>Søkeresultater</h2>
                <p><i>Ditt søk på &laquo;{q}&raquo; ga {result.length} treff</i></p>
                <form action="" method="get">
                    <input type="text" name="q" placeholder={q} />
                </form>

                <ul className="searchResults__results">
                    {result.map(hit => {
                        const typeObj = typeMap[hit.type];
                        const typeString = typeObj.prettyName;
                        return <li><a href={hit.linkUrl}><span>{typeString}:</span> {hit.title}</a></li>
                    })}
                </ul>
            </div>
        </section>
        )
    }
}

module.exports = SearchResults;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/search-results/Component/index.jsx